<template>
  <div v-if="filters.allLocations.length > 0 || filters.allWorkFields.length > 0 || filters.allJobCategories.length > 0 ||
filters.allEmployments.length > 0 || filters.allCareerLevels.length > 0" class="filter__bar-wrapper job_offer_list_wrapper -max-width-limited">
    <!-- Search Bar -->
    <div class="filter__bar-search-wrapper">
      <div class="filter__bar-input-wrapper">
        <span class="icon-search-before"></span>
        <input type="text" class="filter__bar-search-input" v-model="filters.searchQueryInput" :placeholder="$t('filter.search-placeholder')" @keyup.enter="executeApiCallAfterTimeout()" />
        <span v-if="filters.searchQueryInput !== ''" class="icon-close-after" @click="clearSearchQueryInput()"></span>
      </div>
      <div @click="executeApiCallAfterTimeout()" class="filter__bar-search-btn icon-arrow-right-before"></div>
    </div>
    <!-- Filter Bar -->
    <div id="filter__container">

      <div v-if="filters.allLocations.length > 0" id="filter__container-locations-wrapper" class="filter__container-wrapper -hidden">
        <div class="dropdown-btn icon-angle-down-after" @click="showAllLocations()">
          {{ $t("filter.location") }}
        </div>
        <div id="filter__container-locations" class="filter__container-options">
          <div v-for="location in filters.allLocations" :key="location.uid" class="filter-label-wrapper">
            <label :for="location.title">
              <input @click="handleLocation(location.uid, location.title)" type="checkbox" :id="location.title" :checked="isCheckedLocation(location.uid, location.title)" :value="location.uid" />
              {{location.title}}
            </label>
          </div>
        </div>
      </div>
      <div v-if="filters.allWorkFields.length > 0">
        <div v-if="filters.preSelectedWorkField === ''" id="filter__container-work-fields-wrapper" class="filter__container-wrapper -hidden">
          <div class="dropdown-btn icon-angle-down-after" @click="showAllWorkFields()">
            {{ $t("filter.work-field") }}
          </div>
          <div id="filter__container-work-fields" class="filter__container-options">
            <div v-for="workField in filters.allWorkFields" :key="workField.uid" class="filter-label-wrapper">
              <label :for="workField.title">
                <input @click="handleWorkField(workField.uid, workField.title)" type="checkbox" :id="workField.title" :checked="isCheckedWorkField(workField.uid, workField.title)" :value="workField.uid"/>
                {{workField.title}}
              </label>
            </div>
          </div>
        </div>
      </div>
      <div v-if="filters.allJobCategories.length > 0" id="filter__container-categories-wrapper" class="filter__container-wrapper -hidden">
        <div class="dropdown-btn icon-angle-down-after" @click="showAllCategories()">
          {{ $t("filter.category") }}
        </div>
        <div id="filter__container-categories" class="filter__container-options">
          <div v-for="category in filters.allJobCategories" :key="category.uid" class="filter-label-wrapper">
            <label :for="category.title">
              <input @click="handleCategory(category.uid, category.title)" type="checkbox" :id="category.title" :checked="isCheckedCategory(category.uid, category.title)" :value="category.uid" />
              {{category.title}}
            </label>
          </div>
        </div>
      </div>
      <div v-if="filters.allEmployments.length > 0" id="filter__container-employments-wrapper" class="filter__container-wrapper -hidden">
        <div class="dropdown-btn icon-angle-down-after" @click="showAllEmployments()">
          {{ $t("filter.employment") }}
        </div>
        <div id="filter__container-employments" class="filter__container-options">
          <div v-for="employment in filters.allEmployments" :key="employment.uid" class="filter-label-wrapper">
            <label :for="employment.title">
              <input @click="handleEmployment(employment.uid, employment.title)" type="checkbox" :id="employment.title" :checked="isCheckedEmployment(employment.uid, employment.title)" :value="employment.uid" />
              {{employment.title}}
            </label>
          </div>
        </div>
      </div>
      <div v-if="filters.allCareerLevels.length > 0" id="filter__container-career-levels-wrapper" class="filter__container-wrapper -hidden">
        <div class="dropdown-btn icon-angle-down-after" @click="showAllCareerLevels()">
          {{ $t("filter.career-level") }}
        </div>
        <div id="filter__container-career-levels" class="filter__container-options">
          <div v-for="careerLevel in filters.allCareerLevels" :key="careerLevel.uid" class="filter-label-wrapper">
            <label :for="careerLevel.title">
              <input @click="handleCareerLevel(careerLevel.uid, careerLevel.title)" type="checkbox" :id="careerLevel.title" :checked="isCheckedCareerLevel(careerLevel.uid, careerLevel.title)" :value="careerLevel.uid" />
              {{careerLevel.title}}
            </label>
          </div>
        </div>
      </div>
    </div>
    <!-- Filter Tags Container -->
    <div class="filter__container-tags">
      <div v-for="selectedLocation in filters.selectedLocations" :key="selectedLocation.uid"
           class="filter-tags-container" @click="handleLocation(selectedLocation.uid, selectedLocation.title)">
        <span class="icon-close-after">{{selectedLocation.title}}</span>
      </div>
      <div v-for="selectedWorkField in filters.selectedWorkFields" :key="selectedWorkField.uid"
           class="filter-tags-container" @click="handleWorkField(selectedWorkField.uid, selectedWorkField.title)">
        <span class="icon-close-after">{{selectedWorkField.title}}</span>
      </div>
      <div v-for="selectedCategory in filters.selectedCategories" :key="selectedCategory.uid"
           class="filter-tags-container" @click="handleCategory(selectedCategory.uid, selectedCategory.title)">
        <span class="icon-close-after">{{selectedCategory.title}}</span>
      </div>
      <div v-for="selectedEmployment in filters.selectedEmployments" :key="selectedEmployment.uid"
           class="filter-tags-container" @click="handleEmployment(selectedEmployment.uid, selectedEmployment.title)">
        <span class="icon-close-after">{{selectedEmployment.title}}</span>
      </div>
      <div v-for="selectedCareerLevel in filters.selectedCareerLevels" :key="selectedCareerLevel.uid"
           class="filter-tags-container" @click="handleCareerLevel(selectedCareerLevel.uid, selectedCareerLevel.title)">
        <span class="icon-close-after">{{selectedCareerLevel.title}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import {useFilterStore} from "@/stores/filter";
import {useJobOffersStore} from "@/stores/jobOffers";
import {useGlobalStore} from "@/stores";

export default {
  name: "FilterBar",
  data() {
    return {
      showLocation: false,
      showWorkField: false,
      showJobCategories: false,
      showEmployments: false,
      showCareerLevels: false,
      clickedFilterCount: 0, // used to check if filter count === timeout count to only call api if not other select chosen in the meantime
      timeoutCount: 0
    }
  },
  setup() {
    const filters = useFilterStore();

    function isCheckedLocation(uid, title) {
      return filters.isLocationSelected({uid: uid, title: title})
    }

    function isCheckedWorkField(uid, title) {
      return filters.isWorkFieldSelected({uid: uid, title: title})
    }

    function isCheckedCategory(uid, title) {
      return filters.isCategorySelected({uid: uid, title: title})
    }

    function isCheckedEmployment(uid, title) {
      return filters.isEmploymentSelected({uid: uid, title: title})
    }

    function isCheckedCareerLevel(uid, title) {
      return filters.isCareerLevelSelected({uid: uid, title: title})
    }

    return {
      filters,
      isCheckedLocation,
      isCheckedWorkField,
      isCheckedCategory,
      isCheckedEmployment,
      isCheckedCareerLevel
    }
  },
  mounted() {
    // timeout needed in order to attach the event handler to the elements loaded from the store
    setTimeout(() => {
      this.addEventHandler()
    }, 500)
  },
  methods: {
    hideFilterContainer(containerId) {
      let container =
        document.getElementById(containerId);
      container.classList.add('-hidden')
    },
    closeOpenFilterOptions(filterOptionsToClose) {
      for (let i = 0; i < filterOptionsToClose.length; i++) {
        switch (filterOptionsToClose[i]) {
          case 'locations':
            if (this.showLocation) {
              this.showLocation = false
              this.hideFilterContainer('filter__container-locations-wrapper')
            }
            break;
          case 'work-fields':
            if (this.showWorkField) {
              this.showWorkField = false
              this.hideFilterContainer('filter__container-work-fields-wrapper')
            }
            break;
          case 'categories':
            if (this.showJobCategories) {
              this.showJobCategories = false
              this.hideFilterContainer('filter__container-categories-wrapper')
            }
            break;
          case 'employments':
            if (this.showEmployments) {
              this.showEmployments = false
              this.hideFilterContainer('filter__container-employments-wrapper')
            }
            break;
          case 'career-levels':
            if (this.showCareerLevels) {
              this.showCareerLevels = false
              this.hideFilterContainer('filter__container-career-levels-wrapper')
            }
            break;
        }
      }
    },
    showAllLocations() {
      let locations =
        document.getElementById('filter__container-locations-wrapper');
      if (!this.showLocation) {
        this.closeOpenFilterOptions(['work-fields', 'categories', 'employments', 'career-levels'])
        locations.classList.remove('-hidden')
        this.showLocation = !this.showLocation;
      } else {
        this.closeOpenFilterOptions(['locations'])
      }
    },
    showAllWorkFields() {
      let workFields =
        document.getElementById('filter__container-work-fields-wrapper');
      if (!this.showWorkField) {
        this.closeOpenFilterOptions(['locations', 'categories', 'employments', 'career-levels'])
        workFields.classList.remove('-hidden')
        this.showWorkField = !this.showWorkField;
      } else {
        this.closeOpenFilterOptions(['work-fields'])
      }
    },
    showAllCategories() {
      let categories =
        document.getElementById('filter__container-categories-wrapper');
      if (!this.showJobCategories) {
        this.closeOpenFilterOptions(['locations', 'work-fields', 'employments', 'career-levels'])
        categories.classList.remove('-hidden')
        this.showJobCategories = !this.showJobCategories;
      } else {
        this.closeOpenFilterOptions(['categories'])
      }
    },
    showAllEmployments() {
      let employments =
        document.getElementById('filter__container-employments-wrapper');
      if (!this.showEmployments) {
        this.closeOpenFilterOptions(['locations', 'work-fields', 'categories', 'career-levels'])
        employments.classList.remove('-hidden')
        this.showEmployments = !this.showEmployments;
      } else {
        this.closeOpenFilterOptions(['employments'])
      }
    },
    showAllCareerLevels() {
      let careerLevels =
        document.getElementById('filter__container-career-levels-wrapper');
      if (!this.showCareerLevels) {
        this.closeOpenFilterOptions(['locations', 'work-fields', 'categories', 'employments'])
        careerLevels.classList.remove('-hidden')
        this.showCareerLevels = !this.showCareerLevels;
      } else {
        this.closeOpenFilterOptions(['career-levels'])
      }
    },
    executeApiCallAfterTimeout() {
      const jobOfferStore = useJobOffersStore()
      this.clickedFilterCount += 1
      setTimeout(() => {
        this.timeoutCount += 1
        // if other filter element clicked -> waiting till last clicked element is timeouted to fetch data
        // comparing timeout and clicked count in order to refresh timeout before making api call
        if (this.timeoutCount === this.clickedFilterCount) {
          const globals = useGlobalStore()
          globals.loading = true
          setTimeout(() => {
            jobOfferStore.getAllRelevantJobOffers()
            globals.loading = false
          },300)
        }
      }, 500)
    },
    handleLocation(uid, title) {
      const filters = useFilterStore()
      filters.handleSelectedLocations({uid: uid, title: title})
      this.executeApiCallAfterTimeout()
    },
    handleWorkField(uid, title) {
      const filters = useFilterStore()
      filters.handleSelectedWorkFields({uid: uid, title: title})
      this.executeApiCallAfterTimeout()
    },
    handleCategory(uid, title) {
      const filters = useFilterStore()
      filters.handleSelectedCategories({uid: uid, title: title})
      this.executeApiCallAfterTimeout()
    },
    handleEmployment(uid, title) {
      const filters = useFilterStore()
      filters.handleSelectedEmployments({uid: uid, title: title})
      this.executeApiCallAfterTimeout()
    },
    handleCareerLevel(uid, title) {
      const filters = useFilterStore()
      filters.handleSelectedCareerLevels({uid: uid, title: title})
      this.executeApiCallAfterTimeout()
    },
    clearSearchQueryInput() {
      const filters = useFilterStore()
      filters.searchQueryInput = ''
      this.executeApiCallAfterTimeout()
    },
    addEventHandler() {
      const body = document.getElementsByTagName('body')[0];
      body.addEventListener('click', (event) => {
        if (!event.target.closest('.filter__container-wrapper')) {
          this.closeOpenFilterOptions(['locations', 'work-fields', 'categories', 'employments', 'career-levels'])
        }
      })
    }
  }
};
</script>
